export default {"src":"/_next/static/media/flag.145c1322.svg","height":56,"width":56,"blurWidth":0,"blurHeight":0};